import React from "react";
import { Link } from "react-router-dom";
import Stepper from "../../../Components/Stepper/Stepper";
import BrandLogo from "../../../Components/BrandLogo/BrandLogo";

export default function Food(props) {
  return (
    <div className="food bgContainer">
      <div className="blurOverlay">
        <BrandLogo />
        <h3 className="onboardingHeading">خوراک</h3>
        <h6 className="onboardingMessage">
          با تغذیه سالم، عملکردت رو بالا ببر
        </h6>
        <Stepper step={props.step} />
        <Link to="/loginOrRegister" className="mainBtn openAppBtn link">
          بریم تو برنامه
        </Link>
      </div>
    </div>
  );
}
